export default {
	async mounted() {
		await this.$nextTick();
		this.$el.dispatchEvent(new CustomEvent('content-component-mounted', { bubbles: true }));
	}
};
